import { Api } from "./Api.class";
const endpoint = "recruiter/candidates";
const recruiterCandidatesAPI = new Api(endpoint);
export default recruiterCandidatesAPI;
